import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Rect } from "react-native-svg";

export const IconToggle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconToggle"><Rect x="1" y="4.5" width="22" height="15" rx="7.5" stroke="currentColor"/><Circle cx="8.5" cy="12" r="3" fill="currentColor"/></CentralIconBase>;
});

export default IconToggle;
